import { HeldEmailQueuePrimaryView } from "./HeldEmailQueuePrimaryView";
import { HeldEmailQueueSecondaryView } from "./HeldEmailQueueSecondaryView";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";

export function HeldEmailQueueView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <>
      <HeldEmailQueuePrimaryView model={model} />
      <HeldEmailQueueSecondaryView model={model} />
    </>
  );
}
